(function () {
  'use strict';

  // 多个可独立添加的 Stories 区块会引用同一脚本，浏览器端只初始化一次。
  if (typeof window !== 'undefined' && window.__storiesPageScriptLoaded) return;
  if (typeof window !== 'undefined') window.__storiesPageScriptLoaded = true;

  /** 根据所选目标返回需要展示的故事索引。 */
  function getFilteredStoryIndexes(categories, selectedCategory) {
    return categories.reduce(function (indexes, category, index) {
      if (selectedCategory === 'all' || category === selectedCategory) indexes.push(index);
      return indexes;
    }, []);
  }

  /**
   * 把筛选后的故事按原始顺序平均分到上下两行，上行在奇数数量时多一项。
   * 返回值由 CSS Grid 消费，避免依赖当前视口能容纳的固定列数。
   */
  function getTwoRowStoryPositions(itemCount) {
    var parsedItemCount = Number(itemCount);
    if (!Number.isFinite(parsedItemCount) || parsedItemCount <= 0) return [];

    var safeItemCount = Math.floor(parsedItemCount);
    var topRowCount = Math.ceil(safeItemCount / 2);
    var positions = [];

    for (var index = 0; index < safeItemCount; index += 1) {
      var isTopRow = index < topRowCount;
      positions.push({
        row: isTopRow ? 1 : 2,
        column: isTopRow ? index + 1 : index - topRowCount + 1,
      });
    }

    return positions;
  }

  /** 根据拖拽起点计算横向轨道的新滚动位置。 */
  function getStoryDragScrollLeft(startScrollLeft, startPointerX, currentPointerX) {
    var safeScrollLeft = Number(startScrollLeft);
    var safeStartPointerX = Number(startPointerX);
    var safeCurrentPointerX = Number(currentPointerX);
    if (!Number.isFinite(safeScrollLeft)) safeScrollLeft = 0;
    if (!Number.isFinite(safeStartPointerX) || !Number.isFinite(safeCurrentPointerX)) return safeScrollLeft;
    return safeScrollLeft + safeStartPointerX - safeCurrentPointerX;
  }

  /** 计算轮播下一位置，并在首尾之间循环。 */
  function getNextCarouselIndex(currentIndex, itemCount, visibleCount, direction) {
    var lastIndex = Math.max(0, itemCount - Math.max(1, visibleCount));
    if (direction > 0) return currentIndex >= lastIndex ? 0 : currentIndex + 1;
    return currentIndex <= 0 ? lastIndex : currentIndex - 1;
  }

  /**
   * 根据可视区域计算首尾需要复制的卡片数量。
   * 额外复制一项，避免边界动画期间因亚像素或部分露出卡片产生空白。
   */
  function getCarouselCloneCount(itemCount, viewportWidth, cardStep) {
    if (!Number.isFinite(itemCount) || itemCount < 2) return 0;
    if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) return 0;
    if (!Number.isFinite(cardStep) || cardStep <= 0) return 0;
    return Math.min(Math.floor(itemCount), Math.ceil(viewportWidth / cardStep) + 1);
  }

  /**
   * 计算一次前后切换的逻辑索引、渲染索引和边界动画结束后的静默校正位置。
   */
  function getSeamlessCarouselTarget(currentIndex, itemCount, cloneCount, direction) {
    var safeItemCount = Math.max(0, Math.floor(Number(itemCount) || 0));
    var safeCloneCount = Math.max(0, Math.floor(Number(cloneCount) || 0));
    var lastIndex = Math.max(0, safeItemCount - 1);
    var safeCurrentIndex = Math.max(0, Math.min(Math.floor(Number(currentIndex) || 0), lastIndex));

    if (safeItemCount === 0) {
      return { logicalIndex: 0, renderedIndex: 0, normalizationIndex: null };
    }

    var logicalIndex = getNextCarouselIndex(safeCurrentIndex, safeItemCount, 1, direction);
    if (direction > 0 && safeCurrentIndex === lastIndex) {
      return {
        logicalIndex: logicalIndex,
        renderedIndex: safeCloneCount + safeItemCount,
        normalizationIndex: safeCloneCount,
      };
    }
    if (direction < 0 && safeCurrentIndex === 0) {
      return {
        logicalIndex: logicalIndex,
        renderedIndex: Math.max(0, safeCloneCount - 1),
        normalizationIndex: safeCloneCount + lastIndex,
      };
    }
    return {
      logicalIndex: logicalIndex,
      renderedIndex: safeCloneCount + logicalIndex,
      normalizationIndex: null,
    };
  }

  /** 用户启用自动轮播且系统未请求减少动态效果时才允许播放。 */
  function shouldEnableAutoplay(configuredAutoplay, reducedMotion) {
    return Boolean(configuredAutoplay) && !reducedMotion;
  }

  /** 移动端专用轮播仅在 H5 断点内启动，桌面隐藏状态不消耗自动播放定时器。 */
  function shouldRunCarouselAutoplay(configuredAutoplay, reducedMotion, mobileOnly, mobileViewportMatches) {
    if (!shouldEnableAutoplay(configuredAutoplay, reducedMotion)) return false;
    return !mobileOnly || Boolean(mobileViewportMatches);
  }

  /** 校验后台传入的自动播放间隔，并强制满足五秒的无障碍下限。 */
  function getAutoplayDelay(configuredDelay) {
    var parsedDelay = Number(configuredDelay);
    return Number.isFinite(parsedDelay) ? Math.max(5000, parsedDelay) : 5000;
  }

  /** 校验后台设置，单次最多展示两行，非法值回退为一行。 */
  function getProfessionalRowsPerClick(configuredRows) {
    var parsedRows = Number(configuredRows);
    if (!Number.isFinite(parsedRows)) return 1;
    return Math.max(1, Math.min(2, Math.floor(parsedRows)));
  }

  /** 计算下一次点击后的额外可见行数；全部展开后再次点击则回到零行。 */
  function getNextProfessionalVisibleRowCount(currentCount, totalCount, rowsPerClick) {
    var safeCurrentCount = Math.max(0, Math.floor(Number(currentCount) || 0));
    var safeTotalCount = Math.max(0, Math.floor(Number(totalCount) || 0));
    var safeRowsPerClick = getProfessionalRowsPerClick(rowsPerClick);
    if (safeTotalCount > 0 && safeCurrentCount >= safeTotalCount) return 0;
    return Math.min(safeTotalCount, safeCurrentCount + safeRowsPerClick);
  }

  /** 仅在存在额外行且所有额外行均可见时返回完成状态。 */
  function areAllProfessionalRowsVisible(visibleCount, totalCount) {
    var safeVisibleCount = Math.max(0, Math.floor(Number(visibleCount) || 0));
    var safeTotalCount = Math.max(0, Math.floor(Number(totalCount) || 0));
    return safeTotalCount > 0 && safeVisibleCount >= safeTotalCount;
  }

  /** 从受支持的 YouTube 分享地址中提取视频 ID，非法地址返回空字符串。 */
  function getStoriesYouTubeVideoId(candidateUrl) {
    if (typeof candidateUrl !== 'string' || candidateUrl.trim() === '') return '';

    try {
      var parsedUrl = new URL(candidateUrl, 'https://www.youtube.com');
      if (parsedUrl.protocol !== 'https:') return '';

      var hostname = parsedUrl.hostname.toLowerCase();
      var pathParts = parsedUrl.pathname.split('/').filter(Boolean);
      var youtubeId = '';
      var youtubeHosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'];

      if (hostname === 'youtu.be') {
        youtubeId = pathParts[0] || '';
      } else if (youtubeHosts.indexOf(hostname) >= 0) {
        if (pathParts[0] === 'watch') {
          youtubeId = parsedUrl.searchParams.get('v') || '';
        } else if (['embed', 'shorts', 'live'].indexOf(pathParts[0]) >= 0) {
          youtubeId = pathParts[1] || '';
        }
      }
      return /^[A-Za-z0-9_-]{6,32}$/.test(youtubeId) ? youtubeId : '';
    } catch (error) {
      return '';
    }
  }

  /** 返回 YouTube 静态封面与低分辨率回退地址，避免播放前创建官方播放器。 */
  function getStoriesYouTubePosterUrls(candidateUrl) {
    var youtubeId = getStoriesYouTubeVideoId(candidateUrl);
    if (!youtubeId) return null;

    var thumbnailBaseUrl = 'https://i.ytimg.com/vi/' + youtubeId + '/';
    return {
      primary: thumbnailBaseUrl + 'maxresdefault.jpg',
      fallback: thumbnailBaseUrl + 'hqdefault.jpg',
    };
  }

  /** 将受支持平台的分享链接转换为官方嵌入地址，禁止任意第三方页面进入 iframe。 */
  function getStoriesVideoEmbedUrl(candidateUrl, autoplay, customFullscreen) {
    if (typeof candidateUrl !== 'string' || candidateUrl.trim() === '') return '';
    var shouldAutoplay = autoplay !== false;
    var youtubeId = getStoriesYouTubeVideoId(candidateUrl);

    if (youtubeId) {
      // 浏览器会拦截新建 iframe 的有声自动播放；静音启动可确保外层封面一次点击即开始播放。
      var youtubeQuery = shouldAutoplay
        ? '?autoplay=1&mute=1&playsinline=1'
        : '?autoplay=0&controls=0&playsinline=1';
      // 自定义全屏可用时隐藏播放器同名入口，避免 Shorts 回退为普通播放器时出现两个按钮。
      return 'https://www.youtube.com/embed/' + youtubeId + youtubeQuery + (customFullscreen ? '&fs=0' : '');
    }

    try {
      var parsedUrl = new URL(candidateUrl, 'https://www.youtube.com');
      if (parsedUrl.protocol !== 'https:') return '';

      var hostname = parsedUrl.hostname.toLowerCase();
      var pathParts = parsedUrl.pathname.split('/').filter(Boolean);

      var vimeoId = '';
      if (['vimeo.com', 'www.vimeo.com'].indexOf(hostname) >= 0) {
        vimeoId = pathParts[0] || '';
      } else if (hostname === 'player.vimeo.com' && pathParts[0] === 'video') {
        vimeoId = pathParts[1] || '';
      }
      if (/^\d{5,12}$/.test(vimeoId)) {
        var vimeoQuery = shouldAutoplay ? '?autoplay=1&muted=1' : '?autoplay=0&controls=0';
        return 'https://player.vimeo.com/video/' + vimeoId + vimeoQuery + (customFullscreen ? '&fullscreen=0' : '');
      }

      var instagramHosts = ['instagram.com', 'www.instagram.com', 'm.instagram.com'];
      var instagramType = pathParts[0] || '';
      var instagramId = pathParts[1] || '';
      var instagramTypes = ['p', 'reel', 'tv'];

      if (
        instagramHosts.indexOf(hostname) >= 0
        && instagramTypes.indexOf(instagramType) >= 0
        && /^[A-Za-z0-9_-]{5,64}$/.test(instagramId)
      ) {
        return 'https://www.instagram.com/' + instagramType + '/' + instagramId + '/embed/';
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  /** 判断嵌入地址是否属于允许展示的 Instagram 帖子或短视频。 */
  function isStoriesInstagramEmbedUrl(candidateUrl) {
    if (typeof candidateUrl !== 'string' || candidateUrl.trim() === '') return false;

    try {
      var parsedUrl = new URL(candidateUrl);
      var instagramHosts = ['instagram.com', 'www.instagram.com', 'm.instagram.com'];
      var pathParts = parsedUrl.pathname.split('/').filter(Boolean);
      return parsedUrl.protocol === 'https:'
        && instagramHosts.indexOf(parsedUrl.hostname.toLowerCase()) >= 0
        && ['p', 'reel', 'tv'].indexOf(pathParts[0]) >= 0
        && pathParts[2] === 'embed';
    } catch (error) {
      return false;
    }
  }

  /**
   * 返回播放前允许展示的预览资源。
   * Instagram 官方 iframe 会显示账号主页栏，因此只在用户点击后加载。
   */
  function getStoriesVideoPreviewSource(candidateUrl) {
    var youtubePosterUrls = getStoriesYouTubePosterUrls(candidateUrl);
    if (youtubePosterUrls) {
      return {
        type: 'image',
        primary: youtubePosterUrls.primary,
        fallback: youtubePosterUrls.fallback,
      };
    }

    var iframeUrl = getStoriesVideoEmbedUrl(candidateUrl, false);
    if (!iframeUrl) return null;

    if (isStoriesInstagramEmbedUrl(iframeUrl)) {
      return {
        type: 'instagram-iframe',
        url: iframeUrl,
      };
    }

    return {
      type: 'iframe',
      url: iframeUrl,
    };
  }

  /**
   * Instagram 不支持通过跨域 iframe 参数自动播放，因此让已加载的官方预览直接接收首次点击。
   */
  function enableStoriesInstagramNativePlayback(media, trigger, previewIframe) {
    if (!media || !trigger || !previewIframe) return false;

    media.dataset.instagramNativePlayer = 'true';
    trigger.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('tabindex', '-1');
    previewIframe.removeAttribute('aria-hidden');
    previewIframe.removeAttribute('tabindex');
    return true;
  }

  /** 普通 YouTube 使用原生全屏；Shorts 及其余已支持的平台使用统一的全屏开关。 */
  function shouldUseStoriesCustomFullscreen(candidateUrl) {
    if (!getStoriesVideoEmbedUrl(candidateUrl)) return false;
    if (!getStoriesYouTubeVideoId(candidateUrl)) return true;
    return new URL(candidateUrl, 'https://www.youtube.com').pathname.split('/')[1] === 'shorts';
  }

  /** 同时校验来源与浏览器能力；不支持容器全屏时保留官方播放器默认控件。 */
  function canUseStoriesCustomFullscreen(media, candidateUrl) {
    return Boolean(media && shouldUseStoriesCustomFullscreen(candidateUrl)
      && (typeof media.requestFullscreen === 'function' || typeof media.webkitRequestFullscreen === 'function')
      && (typeof document.exitFullscreen === 'function' || typeof document.webkitExitFullscreen === 'function'));
  }

  /** 为 Shorts、Instagram 等创建可退出的容器全屏开关，保留当前 iframe 和播放状态。 */
  function initializeStoriesCustomFullscreen(media, candidateUrl) {
    if (!canUseStoriesCustomFullscreen(media, candidateUrl)) return;
    if (media.querySelector('.stories-video__fullscreen-button')) return;
    var requestFullscreen = media.requestFullscreen || media.webkitRequestFullscreen;
    var exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen;
    media.dataset.customFullscreen = 'true';
    var fullscreenButton = document.createElement('button');
    fullscreenButton.className = 'stories-video__fullscreen-button';
    fullscreenButton.type = 'button';
    var wasFullscreen = false;

    /** 同步按钮状态；通过按钮、Esc 或浏览器退出时都恢复入口和焦点。 */
    function updateFullscreenState() {
      var isFullscreen = (document.fullscreenElement || document.webkitFullscreenElement) === media;
      var label = isFullscreen ? 'Exit fullscreen' : 'View fullscreen';
      var iconPath = isFullscreen
        ? 'M9 4v5H4M20 9h-5V4M15 20v-5h5M4 15h5v5'
        : 'M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5';
      fullscreenButton.setAttribute('aria-label', label);
      fullscreenButton.setAttribute('title', label);
      fullscreenButton.setAttribute('aria-pressed', String(isFullscreen));
      fullscreenButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + iconPath + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (wasFullscreen && !isFullscreen) fullscreenButton.focus({ preventScroll: true });
      wasFullscreen = isFullscreen;
    }

    fullscreenButton.addEventListener('click', function (event) {
      // 阻止区块的播放事件接管按钮点击，避免重新创建 iframe 导致视频重播。
      event.preventDefault();
      event.stopPropagation();
      var isFullscreen = (document.fullscreenElement || document.webkitFullscreenElement) === media;
      if (!isFullscreen) {
        var bounds = media.getBoundingClientRect();
        if (bounds.width > 0 && bounds.height > 0) {
          media.style.setProperty('--stories-video-fullscreen-ratio', String(bounds.width / bounds.height));
        }
      }
      try {
        var result = isFullscreen ? exitFullscreen.call(document) : requestFullscreen.call(media);
        if (result && typeof result.catch === 'function') {
          result.catch(function (error) {
            console.warn('视频全屏切换失败。', error);
            updateFullscreenState();
          });
        }
      } catch (error) {
        console.warn('视频全屏切换失败。', error);
        updateFullscreenState();
      }
    });
    media.addEventListener('fullscreenchange', updateFullscreenState);
    media.addEventListener('webkitfullscreenchange', updateFullscreenState);
    media.appendChild(fullscreenButton);
    updateFullscreenState();
  }

  /** 点击封面后在原视频框内创建官方 iframe，不触发外部页面跳转。 */
  function initializeStoriesVideos(scope) {
    scope.querySelectorAll('[data-stories-video-root]').forEach(function (section) {
      if (section.dataset.videoInitialized === 'true') return;
      section.dataset.videoInitialized = 'true';

      // 只有未上传自定义封面的卡片才加载平台预览，避免重复请求外部资源。
      section.querySelectorAll('[data-stories-video-trigger]').forEach(function (trigger) {
        var media = trigger.closest('[data-stories-video-container]');
        var poster = media ? media.querySelector('[data-stories-video-poster]') : null;
        if (!poster || poster.dataset.hasCustomCover === 'true') return;

        var previewSource = getStoriesVideoPreviewSource(trigger.dataset.videoUrl);
        if (!previewSource) return;

        if (previewSource.type === 'image') {
          var previewImage = document.createElement('img');
          previewImage.className = 'stories-video__preview-image';
          previewImage.src = previewSource.primary;
          previewImage.alt = '';
          previewImage.loading = 'lazy';
          previewImage.decoding = 'async';
          previewImage.width = 1280;
          previewImage.height = 720;
          previewImage.addEventListener('error', function () {
            if (previewImage.src === previewSource.fallback) {
              previewImage.remove();
              return;
            }
            previewImage.src = previewSource.fallback;
          });
          poster.replaceChildren(previewImage);
          return;
        }

        var previewIframe = document.createElement('iframe');
        previewIframe.className = 'stories-video__preview';
        previewIframe.src = previewSource.url;
        previewIframe.title = (trigger.dataset.videoTitle || 'Video') + ' preview';
        previewIframe.loading = 'lazy';
        previewIframe.referrerPolicy = 'strict-origin-when-cross-origin';
        if (previewSource.type === 'instagram-iframe') {
          previewIframe.setAttribute('scrolling', 'no');
        }
        previewIframe.setAttribute('aria-hidden', 'true');
        previewIframe.setAttribute('tabindex', '-1');
        if (previewSource.type === 'instagram-iframe') {
          enableStoriesInstagramNativePlayback(media, trigger, previewIframe);
        }
        poster.replaceChildren(previewIframe);
        initializeStoriesCustomFullscreen(media, trigger.dataset.videoUrl);
      });

      section.addEventListener('click', function (event) {
        if (!event.target || typeof event.target.closest !== 'function') return;

        // 无论点击播放图标、预览封面还是视频框空白处，都统一触发当前视频框的播放按钮。
        var media = event.target.closest('[data-stories-video-container]');
        if (!media || !section.contains(media)) return;
        var trigger = event.target.closest('[data-stories-video-trigger]')
          || media.querySelector('[data-stories-video-trigger]');
        if (!trigger) return;

        var embedUrl = getStoriesVideoEmbedUrl(
          trigger.dataset.videoUrl, true, canUseStoriesCustomFullscreen(media, trigger.dataset.videoUrl)
        );
        if (!embedUrl) return;

        var iframe = document.createElement('iframe');
        iframe.className = 'stories-video__iframe';
        iframe.src = embedUrl;
        iframe.title = trigger.dataset.videoTitle || 'Play video';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        if (isStoriesInstagramEmbedUrl(embedUrl)) iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('tabindex', '0');

        var carousel = trigger.closest('[data-stories-media]');
        if (carousel) carousel.setAttribute('data-video-active', '');

        media.dataset.videoPlaying = 'true';
        media.replaceChildren(iframe);

        // 普通 YouTube 保留原生按钮；Shorts 和其他受支持平台只提供一个容器全屏入口。
        initializeStoriesCustomFullscreen(media, trigger.dataset.videoUrl);

        iframe.addEventListener('load', function () {
          iframe.focus();
        }, { once: true });
      });
    });
  }

  function initializeProfessionalTestimonials(scope) {
    scope.querySelectorAll('[data-stories-professionals]').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var loadMoreButton = section.querySelector('[data-stories-professionals-toggle]');
      var loadMoreActions = loadMoreButton
        ? loadMoreButton.closest('.stories-professionals__actions')
        : null;
      var extraRows = Array.from(section.querySelectorAll('[data-professional-extra-row]'));
      if (!loadMoreButton || extraRows.length === 0) return;

      var visibleRowCount = 0;
      var rowsPerClick = getProfessionalRowsPerClick(section.dataset.revealRows);
      var expandLabel = loadMoreButton.dataset.expandLabel
        || loadMoreButton.textContent.trim()
        || 'Show More Testimonials';
      var collapseLabel = loadMoreButton.dataset.collapseLabel
        || 'Show Fewer Testimonials';

      /** 根据额外内容是否全部可见，更新按钮文案和无障碍展开状态。 */
      function updateToggleState() {
        var allRowsVisible = areAllProfessionalRowsVisible(visibleRowCount, extraRows.length);
        loadMoreButton.textContent = allRowsVisible
          ? collapseLabel
          : expandLabel;
        loadMoreButton.setAttribute('aria-expanded', String(allRowsVisible));
        if (loadMoreActions) {
          loadMoreActions.dataset.allRowsVisible = String(allRowsVisible);
        }
      }

      /** 展示到指定的累计行数；主题编辑器选中隐藏 block 时也复用该逻辑。 */
      function revealRowsThrough(nextVisibleRowCount) {
        nextVisibleRowCount = Math.max(visibleRowCount, Math.min(extraRows.length, nextVisibleRowCount));
        for (var rowIndex = visibleRowCount; rowIndex < nextVisibleRowCount; rowIndex += 1) {
          extraRows[rowIndex].hidden = false;
        }

        visibleRowCount = nextVisibleRowCount;
        updateToggleState();
      }

      /** 隐藏所有额外行，恢复为两行 YouTube 加一行 Instagram 的首屏状态。 */
      function collapseExtraRows() {
        for (var rowIndex = 0; rowIndex < extraRows.length; rowIndex += 1) {
          extraRows[rowIndex].hidden = true;
        }

        visibleRowCount = 0;
        updateToggleState();
      }

      loadMoreButton.addEventListener('click', function () {
        var nextVisibleRowCount = getNextProfessionalVisibleRowCount(
          visibleRowCount,
          extraRows.length,
          rowsPerClick
        );

        if (nextVisibleRowCount === 0 && visibleRowCount >= extraRows.length) {
          collapseExtraRows();
          return;
        }

        revealRowsThrough(nextVisibleRowCount);
      });

      // 在主题编辑器中选中隐藏 block 时，自动展示它所在行，便于继续编辑。
      section.addEventListener('shopify:block:select', function (event) {
        if (!event.target || typeof event.target.closest !== 'function') return;
        var selectedRow = event.target.closest('[data-professional-extra-row]');
        var selectedRowIndex = extraRows.indexOf(selectedRow);
        if (selectedRowIndex < 0) return;
        revealRowsThrough(selectedRowIndex + 1);
      });
    });
  }

  function initializeGlobalStories(scope) {
    scope.querySelectorAll('[data-stories-global]').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var filters = Array.from(section.querySelectorAll('[data-story-filter]'));
      var cards = Array.from(section.querySelectorAll('[data-story-category]'));
      var track = section.querySelector('[data-story-track]');

      /** 把当前可见卡片按原顺序排成均衡的上下两行。 */
      function positionVisibleCards(visibleIndexes) {
        var positions = getTwoRowStoryPositions(visibleIndexes.length);

        visibleIndexes.forEach(function (cardIndex, visibleIndex) {
          var card = cards[cardIndex];
          var position = positions[visibleIndex];
          card.style.setProperty('--stories-global-card-row', String(position.row));
          card.style.setProperty('--stories-global-card-column', String(position.column));
        });

        if (track) track.scrollLeft = 0;
      }

      var initialVisibleIndexes = getFilteredStoryIndexes(cards.map(function (card) {
        return card.dataset.storyCategory;
      }), 'all');
      positionVisibleCards(initialVisibleIndexes);

      filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
          var selectedCategory = filter.dataset.storyFilter;
          var visibleIndexes = getFilteredStoryIndexes(cards.map(function (card) {
            return card.dataset.storyCategory;
          }), selectedCategory);

          filters.forEach(function (candidate) {
            candidate.setAttribute('aria-pressed', String(candidate === filter));
          });
          cards.forEach(function (card, index) {
            card.hidden = !visibleIndexes.includes(index);
          });
          positionVisibleCards(visibleIndexes);
        });
      });

      if (track) {
        var activePointerId = null;
        var dragStartX = 0;
        var dragStartScrollLeft = 0;
        var dragMoved = false;
        var suppressNextClick = false;

        // 触摸屏和触控板使用浏览器原生滚动；这里只增强桌面鼠标拖拽。
        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          activePointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartScrollLeft = track.scrollLeft;
          dragMoved = false;
        });
        track.addEventListener('pointermove', function (event) {
          if (activePointerId !== event.pointerId) return;
          if (Math.abs(event.clientX - dragStartX) > 5) {
            dragMoved = true;
            track.dataset.dragging = 'true';
            // 只有确认发生拖拽后才捕获指针，避免普通点击被重定向到轨道而无法播放视频。
            if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
          }
          if (!dragMoved) return;
          event.preventDefault();
          track.scrollLeft = getStoryDragScrollLeft(dragStartScrollLeft, dragStartX, event.clientX);
        });
        track.addEventListener('pointerup', function (event) {
          if (activePointerId !== event.pointerId) return;
          suppressNextClick = dragMoved;
          delete track.dataset.dragging;
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          activePointerId = null;
          // 若浏览器没有在本次拖拽后派发 click，立即解除保护，避免误伤下一次正常点击。
          window.setTimeout(function () {
            suppressNextClick = false;
          }, 0);
        });
        track.addEventListener('pointercancel', function (event) {
          if (activePointerId !== event.pointerId) return;
          suppressNextClick = false;
          delete track.dataset.dragging;
          activePointerId = null;
        });
        track.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
        track.addEventListener('click', function (event) {
          if (!suppressNextClick) return;
          suppressNextClick = false;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);
      }

    });
  }

  function initializeMediaCarousels(scope) {
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileViewportQuery = window.matchMedia('(max-width: 749px)');

    scope.querySelectorAll('[data-stories-media]').forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var viewport = section.querySelector('[data-media-viewport]');
      var cards = Array.from(section.querySelectorAll('[data-media-card]:not([data-media-clone])'));
      var mobileOnly = section.hasAttribute('data-mobile-only-carousel');
      var dots = Array.from(section.querySelectorAll('[data-media-dot]'));
      var previous = section.querySelector('[data-media-previous]');
      var next = section.querySelector('[data-media-next]');
      var currentIndex = 0;
      var cloneCount = 0;
      var renderedCards = [];
      var intervalId = null;
      var pausedByPointer = false;
      var pausedByFocus = false;
      var scrollFrame = null;
      var scrollSettleTimer = null;
      var resizeFrame = null;
      var pendingNormalizationIndex = null;
      var pendingRenderedIndex = null;

      if (!viewport || cards.length === 0) return;

      /** 根据卡片当前几何位置返回相对于滚动容器的目标位置。 */
      function getCardScrollLeft(card) {
        var viewportRect = viewport.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        return viewport.scrollLeft + cardRect.left - viewportRect.left;
      }

      /** 读取相邻真实卡片之间的步长，包含 CSS gap。 */
      function getCardStep() {
        if (cards.length > 1) {
          return Math.abs(cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left);
        }
        return cards[0].getBoundingClientRect().width;
      }

      /** 克隆项仅用于视觉缓冲，必须从键盘顺序和辅助技术树中移除。 */
      function prepareClone(card, logicalIndex) {
        var clone = card.cloneNode(true);
        clone.dataset.mediaClone = '';
        clone.dataset.mediaIndex = String(logicalIndex);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.inert = true;
        clone.querySelectorAll('[id]').forEach(function (element) {
          element.removeAttribute('id');
        });
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      /** 返回当前最靠近视口起点的渲染卡片索引。 */
      function getNearestRenderedIndex() {
        if (renderedCards.length === 0) return 0;
        return renderedCards.reduce(function (bestIndex, card, index) {
          var bestDistance = Math.abs(getCardScrollLeft(renderedCards[bestIndex]) - viewport.scrollLeft);
          var candidateDistance = Math.abs(getCardScrollLeft(card) - viewport.scrollLeft);
          return candidateDistance < bestDistance ? index : bestIndex;
        }, 0);
      }

      function updateControls() {
        dots.forEach(function (dot, index) {
          var active = index === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      /** 使用指定滚动行为定位渲染轨道中的卡片。 */
      function scrollToRenderedIndex(renderedIndex, behavior) {
        var targetCard = renderedCards[renderedIndex];
        if (!targetCard) return;
        viewport.scrollTo({
          left: getCardScrollLeft(targetCard),
          behavior: behavior,
        });
      }

      /** 无动画校正克隆边界，用户只会看到连续内容。 */
      function normalizeToRenderedIndex(renderedIndex) {
        var previousSnapType = viewport.style.scrollSnapType;
        viewport.style.scrollSnapType = 'none';
        scrollToRenderedIndex(renderedIndex, 'auto');
        window.requestAnimationFrame(function () {
          viewport.style.scrollSnapType = previousSnapType;
        });
      }

      /** 通过分页点或尺寸变化直接定位某个真实卡片。 */
      function goTo(index, behavior) {
        var maximumIndex = Math.max(0, cards.length - 1);
        currentIndex = Math.max(0, Math.min(index, maximumIndex));
        pendingNormalizationIndex = null;
        pendingRenderedIndex = null;
        scrollToRenderedIndex(cloneCount + currentIndex, behavior || (reducedMotionQuery.matches ? 'auto' : 'smooth'));
        updateControls();
      }

      /** 执行一次无缝前进或后退，并记录动画结束后的真实卡片位置。 */
      function move(direction) {
        if (cards.length < 2) return;
        var target = getSeamlessCarouselTarget(currentIndex, cards.length, cloneCount, direction);
        currentIndex = target.logicalIndex;
        pendingRenderedIndex = target.renderedIndex;
        pendingNormalizationIndex = target.normalizationIndex;
        scrollToRenderedIndex(target.renderedIndex, reducedMotionQuery.matches ? 'auto' : 'smooth');
        updateControls();

        // 关闭动画时不会产生持续滚动事件，需要立即完成边界校正。
        if (reducedMotionQuery.matches && pendingNormalizationIndex !== null) {
          normalizeToRenderedIndex(pendingNormalizationIndex);
          pendingNormalizationIndex = null;
          pendingRenderedIndex = null;
        }
      }

      /** 滚动停止后，把首尾克隆项静默替换为对应的真实卡片。 */
      function settleCarouselPosition() {
        var nearestRenderedIndex = getNearestRenderedIndex();
        var nearestCard = renderedCards[nearestRenderedIndex];
        if (!nearestCard || Math.abs(getCardScrollLeft(nearestCard) - viewport.scrollLeft) > 2) return;

        if (pendingNormalizationIndex !== null && pendingRenderedIndex === nearestRenderedIndex) {
          normalizeToRenderedIndex(pendingNormalizationIndex);
          pendingNormalizationIndex = null;
          pendingRenderedIndex = null;
          return;
        }

        // 触摸或触控板直接滑入克隆区时，也要归位到对应真实卡片。
        if (nearestCard.hasAttribute('data-media-clone')) {
          var logicalIndex = Math.max(0, Math.min(cards.length - 1, Number(nearestCard.dataset.mediaIndex) || 0));
          currentIndex = logicalIndex;
          pendingNormalizationIndex = null;
          pendingRenderedIndex = null;
          normalizeToRenderedIndex(cloneCount + logicalIndex);
          updateControls();
        }
      }

      /** 根据当前视口重新构建足量的首尾克隆项。 */
      function rebuildClones() {
        viewport.querySelectorAll('[data-media-clone]').forEach(function (clone) {
          clone.remove();
        });

        cards.forEach(function (card, index) {
          card.dataset.mediaIndex = String(index);
        });

        cloneCount = getCarouselCloneCount(cards.length, viewport.clientWidth, getCardStep());
        if (cloneCount > 0) {
          var leadingFragment = document.createDocumentFragment();
          var trailingFragment = document.createDocumentFragment();
          var leadingStartIndex = cards.length - cloneCount;

          cards.slice(leadingStartIndex).forEach(function (card, index) {
            leadingFragment.appendChild(prepareClone(card, leadingStartIndex + index));
          });
          cards.slice(0, cloneCount).forEach(function (card, index) {
            trailingFragment.appendChild(prepareClone(card, index));
          });

          viewport.insertBefore(leadingFragment, viewport.firstChild);
          viewport.appendChild(trailingFragment);
        }

        renderedCards = Array.from(viewport.querySelectorAll('[data-media-card]'));
        pendingNormalizationIndex = null;
        pendingRenderedIndex = null;
        normalizeToRenderedIndex(cloneCount + currentIndex);
        section.dataset.carouselReady = 'true';
        updateControls();
      }

      function stopAutoplay() {
        if (intervalId) window.clearInterval(intervalId);
        intervalId = null;
        viewport.setAttribute('aria-live', 'polite');
      }

      function startAutoplay() {
        stopAutoplay();
        var configured = section.dataset.autoplay === 'true';
        if (section.hasAttribute('data-video-active')) return;
        if (!shouldRunCarouselAutoplay(
          configured,
          reducedMotionQuery.matches,
          mobileOnly,
          mobileViewportQuery.matches
        ) || pausedByPointer || pausedByFocus) return;
        var delay = getAutoplayDelay(section.dataset.autoplayDelay);
        viewport.setAttribute('aria-live', 'off');
        intervalId = window.setInterval(function () {
          move(1);
        }, delay);
      }

      if (previous) previous.addEventListener('click', function () {
        move(-1);
        startAutoplay();
      });
      if (next) next.addEventListener('click', function () {
        move(1);
        startAutoplay();
      });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          goTo(index);
          startAutoplay();
        });
      });

      section.addEventListener('mouseenter', function () {
        pausedByPointer = true;
        stopAutoplay();
      });
      section.addEventListener('mouseleave', function () {
        pausedByPointer = false;
        startAutoplay();
      });
      section.addEventListener('focusin', function () {
        pausedByFocus = true;
        stopAutoplay();
      });
      section.addEventListener('focusout', function (event) {
        if (section.contains(event.relatedTarget)) return;
        pausedByFocus = false;
        startAutoplay();
      });
      // 同步触摸滑动或触控板滚动后的分页状态。
      viewport.addEventListener('scroll', function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          var nearestCard = renderedCards[getNearestRenderedIndex()];
          if (!nearestCard) return;
          currentIndex = Math.max(0, Math.min(cards.length - 1, Number(nearestCard.dataset.mediaIndex) || 0));
          updateControls();
        });

        if (scrollSettleTimer) window.clearTimeout(scrollSettleTimer);
        scrollSettleTimer = window.setTimeout(settleCarouselPosition, 120);
      }, { passive: true });

      if ('onscrollend' in viewport) {
        viewport.addEventListener('scrollend', settleCarouselPosition);
      }
      window.addEventListener('resize', function () {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(rebuildClones);
      });
      reducedMotionQuery.addEventListener('change', startAutoplay);
      if (mobileOnly) {
        mobileViewportQuery.addEventListener('change', function () {
          rebuildClones();
          startAutoplay();
        });
      }

      if (cards.length < 2) {
        if (previous) previous.disabled = true;
        if (next) next.disabled = true;
      }
      rebuildClones();
      startAutoplay();
    });
  }

  function initializeStoriesPage(scope) {
    initializeStoriesVideos(scope);
    initializeProfessionalTestimonials(scope);
    initializeGlobalStories(scope);
    initializeMediaCarousels(scope);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeStoriesPage(document); });
    } else {
      initializeStoriesPage(document);
    }
    document.addEventListener('shopify:section:load', function (event) {
      initializeStoriesPage(event.target);
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      getFilteredStoryIndexes: getFilteredStoryIndexes,
      getTwoRowStoryPositions: getTwoRowStoryPositions,
      getStoryDragScrollLeft: getStoryDragScrollLeft,
      getNextCarouselIndex: getNextCarouselIndex,
      getCarouselCloneCount: getCarouselCloneCount,
      getSeamlessCarouselTarget: getSeamlessCarouselTarget,
      getAutoplayDelay: getAutoplayDelay,
      shouldEnableAutoplay: shouldEnableAutoplay,
      shouldRunCarouselAutoplay: shouldRunCarouselAutoplay,
      getProfessionalRowsPerClick: getProfessionalRowsPerClick,
      getNextProfessionalVisibleRowCount: getNextProfessionalVisibleRowCount,
      areAllProfessionalRowsVisible: areAllProfessionalRowsVisible,
      getStoriesYouTubePosterUrls: getStoriesYouTubePosterUrls,
      getStoriesVideoPreviewSource: getStoriesVideoPreviewSource,
      getStoriesVideoEmbedUrl: getStoriesVideoEmbedUrl,
      shouldUseStoriesCustomFullscreen: shouldUseStoriesCustomFullscreen,
      isStoriesInstagramEmbedUrl: isStoriesInstagramEmbedUrl,
      enableStoriesInstagramNativePlayback: enableStoriesInstagramNativePlayback,
      getProfessionalVideoEmbedUrl: getStoriesVideoEmbedUrl,
    };
  }
})();
